import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
{/*     <App />
 */} 
 <br></br><br></br><br></br>
<center>EPIC Store is being refreshed for 25-26 school year. Until then have a few good weeks, earn some epic points, and then you'll be ready to cash in those points for epic rewards on Sept 2nd 2025!</center> 
  </React.StrictMode>
);
